import { createSpacingTokens } from './spacing';
import { elevations } from './elevation';
import { blur } from './blur';
import { fontFamily, fonts, monoFontFamily } from './font';
import { layouts } from './layout';
import { colors } from '../../colors';
import { applyColorAlpha } from '../utils';
import { animationTokens } from './animations';
import { radius } from './radius';
import * as componentSpecificTokens from './componentSpecific';
import { zIndex } from './zIndex';
import { breakpoint } from './breakpoint';
import { motion } from './motion';
const spacing = createSpacingTokens();
const productColors = {
    GoToMeeting: '#F68D2E',
    GoToRoom: '#F68D2E',
    GoToConnect: '#C4D600',
    GoToWebinar: '#00C0F3',
    GoToAssist: '#24658a',
    GoToResolve: '#7D33FF',
    GoToTraining: '#992977',
    OpenVoice: '#a28bc4',
    Jive: '#cfe012',
};
export const lightInteractive01 = colors.blue.b500;
export const darkInteractive01 = colors.blue.b400;
export const lightUi05 = applyColorAlpha(colors.neutrals.n300, 0.16);
export const darkUi05 = applyColorAlpha(colors.neutrals.n000, 0.24);
export const lightBorder = applyColorAlpha(colors.neutrals.n500, 0.24);
export const darkBorder = applyColorAlpha(colors.neutrals.n000, 0.24);
export const lightHover = applyColorAlpha(colors.blue.b100, 0.44);
export const darkHover = applyColorAlpha(colors.blue.b300, 0.12);
export const lightPressed = applyColorAlpha(colors.blue.b100, 0.8);
export const darkPressed = applyColorAlpha(colors.blue.b300, 0.24);
export const lightFocus = colors.blue.b600;
export const darkFocus = colors.blue.b300;
export const lightHighlight = `0 0 0 5px ${applyColorAlpha(colors.blue.b400, 0.24)}`;
export const darkHighlight = `0 0 0 5px ${applyColorAlpha(colors.blue.b400, 0.24)}`;
export const commonTokens = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, blur), elevations), { 'font-family': fontFamily, 'font-family-mono': monoFontFamily, 'menu-width': '240px', 'topbar-background': 'var(--goto-ui-base-01)', 'topbar-border': 'var(--goto-border)', 'navigation-rail-background': 'var(--goto-ui-base-01)', 'navigation-rail-border-right': 'var(--goto-border)', 'navigation-rail-item-hover': 'var(--goto-hover-tertiary)', 'navigation-rail-item-active': 'var(--goto-pressed-tertiary)', 'navigation-rail-item-selected': 'transparent', 'navigation-rail-item-disabled': 'transparent', 'navigation-rail-icon': 'var(--goto-text-02)', 'navigation-rail-icon-selected': 'var(--goto-icon-01)', 'navigation-rail-icon-disabled': 'var(--goto-text-03)', 'navigation-rail-text': 'var(--goto-text-02)', 'navigation-rail-text-selected': 'var(--goto-text-02)', 'navigation-rail-text-disabled': 'var(--goto-text-03)', 'navigation-rail-focus': 'var(--goto-focus)', 'navigation-rail-highlight': 'var(--goto-highlight)' }), fonts), layouts), productColors), spacing), animationTokens), radius), zIndex), breakpoint), motion), componentSpecificTokens);
